<ion-header>
  <ion-toolbar>
    <ion-title>PSI <strong>Pocket</strong></ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="toggleSettings()" fill="clear">
        <ion-icon slot="icon-only" name="ellipsis-vertical-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="closeMenu()" fill="clear">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  
  <!-- Settings dropdown -->
  <div *ngIf="showSettings" class="settings-dropdown">
    <ion-item button (click)="selectProfile()">
      <ion-icon slot="start" name="repeat"></ion-icon>
      <ion-label>Change Profile</ion-label>
    </ion-item>
    <ion-item button (click)="editMenu()">
      <ion-icon slot="start" name="settings"></ion-icon>
      <ion-label>Customize Profile</ion-label>
    </ion-item>
    <ion-item>
      <ion-icon slot="start" name="moon"></ion-icon>
      <ion-label>Toggle Dark Theme</ion-label>
      <ion-toggle [(ngModel)]="isDarkmode" (ionChange)="toggleDarkMode($event)" slot="end"></ion-toggle>
    </ion-item>
  </div>
</ion-header>

<ion-content>
  <ion-list>
    <div *ngFor="let page of appPages">
      <!-- Main page without subpages -->
      <ion-item button *ngIf="!page.subPages" (click)="navigate(page.url)">
        <ion-icon slot="start" [name]="page.icon"></ion-icon>
        <ion-label>{{page.title}}</ion-label>
      </ion-item>

      <!-- Main page with subpages -->
      <div *ngIf="page.subPages">
        <ion-item button (click)="toggleDropdown(page.title)">
          <ion-icon slot="start" [name]="page.icon || 'stats-chart'"></ion-icon>
          <ion-label>{{page.title}}</ion-label>
          <ion-icon 
            *ngIf="!isDropdownOpen(page.title)" 
            slot="end" 
            name="chevron-forward">
          </ion-icon>
          <ion-icon 
            *ngIf="isDropdownOpen(page.title)" 
            slot="end" 
            name="chevron-down">
          </ion-icon>
        </ion-item>
        
        <!-- Subpages -->
        <div *ngIf="isDropdownOpen(page.title)" class="submenu">
          <ng-container *ngFor="let subpage of page.subPages">
            <ion-item 
              *ngIf="subpage.display"
              button 
              (click)="navigate(subpage.url)"
              class="submenu-item">
              <ion-icon *ngIf="subpage.icon" slot="start" [name]="subpage.icon"></ion-icon>
              <ion-label>{{subpage.title}}</ion-label>
            </ion-item>
          </ng-container>
        </div>
      </div>
    </div>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-item button (click)="navigate('/infopage')">
    <ion-icon slot="start" name="help-circle"></ion-icon>
    <ion-label>FAQ</ion-label>
  </ion-item>
</ion-footer>

